import * as httpx from "httpx"
import * as events from "./events"
import { CancellablePromise } from "real-cancellable-promise"
import {
	DocumentSearchRequest,
	DocumentSearchResponse,
	DocumentPatchRequest,
	DocumentPatchResponse,
	DocumentUploadResponse,
} from "brandguard/brandguard.document_pb"

export function upload(
	data: FormData,
	file: File,
	bid: string,
	...options: httpx.option[]
): CancellablePromise<DocumentUploadResponse> {
	data.append("content", file)
	return httpx
		.upload<DocumentUploadResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/document/imports/file`, data, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages || [],
		} as DocumentUploadResponse))
}

export function search(
	bid: string,
	req: DocumentSearchRequest,
	...options: httpx.option[]
): CancellablePromise<DocumentSearchResponse> {
	return httpx.get<DocumentSearchResponse>(`${httpx.urlstorage.host()}/bg/document/${bid}`, req, ...options).then((resp) => ({
		...resp,
		items: (resp.items || []).map((item) => ({ media: item.media, event: events.zero(item.event), pages: item.pages || [] })),
	}))
}

export function publish(
	id: string,
	bid: string,
	req: DocumentPatchRequest,
	...options: httpx.option[]
): Promise<DocumentPatchResponse> {
	return httpx
		.post<DocumentPatchResponse>(`${httpx.urlstorage.host()}/bg/document/${bid}/${id}/reviewed`, req, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages || [],
		}))
}
